import { GetServerSideProps } from "next";
import styled from "@emotion/styled";
import { PageTitle } from "components/core/typography/PageTitle";
import { ContentGridMixContentQuery } from "components/domain/contents/ContentGridMixContentQuery";
import {
  MixContentDocument,
  Mix_Content_Status_Enum,
  Order_By,
} from "graphql/generated";
import { getClient } from "utils/client";

const LIMIT = 20;

const buildQueryVariables = (): MixContentQueryVariables => ({
  where: {
    status: {
      _eq: Mix_Content_Status_Enum.Published,
    },
    isoriginal: {
      _eq: true,
    },
    released: {
      _eq: true,
    },
  },
  orderBy: [{ updatedate: Order_By.Desc }, { id: Order_By.Asc }],
  limit: LIMIT,
  offset: 0,
});

const Container = styled.div`
  width: 100%;
`;

const OriginalPage = () => {
  return (
    <Container>
      <PageTitle>오리지널 콘텐츠</PageTitle>
      <ContentGridMixContentQuery
        contentSection="original-page"
        variables={buildQueryVariables()}
        limit={LIMIT}
      />
    </Container>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const client = getClient({
    ctx,
  });

  await client.query<MixContentQuery, MixContentQueryVariables>({
    query: MixContentDocument,
    variables: buildQueryVariables(),
  });

  return {
    props: {
      __APOLLO_CACHE_DATA__: client.extract(),
    },
  };
};

export default OriginalPage;
